/** An item shown only while a query is active. */
export const VISIBILITY_SEARCH = "search";

/** An item shown only while no query is active. */
export const VISIBILITY_BROWSE = "browse";

/**
 * Whether an item renders under the given query state. An item without a `visibility` renders in
 * both states; `"search"` renders only while a query is active and `"browse"` only while none is.
 *
 * @param {unknown} item
 * @param {boolean} hasQuery
 * @returns {boolean}
 */
export function isVisibleForQuery(item, hasQuery) {
  const visibility = item?.visibility;

  if (visibility === VISIBILITY_SEARCH) {
    return hasQuery;
  }
  if (visibility === VISIBILITY_BROWSE) {
    return !hasQuery;
  }

  return true;
}
